import axios from 'axios';
import { CUSTOMER_API_URL } from '../../constants';
import { Request } from '../../types/api/validateDeliveryAddress/request';
import { Response } from '../../types/api/validateDeliveryAddress/response';

export const validateDeliveryAddress: (
  authorizationToken: string,
  request: Request
) => Promise<
  | { data: Response }
  | {
      error: { status: number; message: string };
    }
> = async (authorizationToken: string, request: Request) => {
  try {
    const result = await axios.post(`${CUSTOMER_API_URL}?action=validateDeliveryAddress`, request, {
      headers: { Authorization: authorizationToken },
    });

    return {
      data: result.data,
    };
  } catch (e: any) {
    // response.status(xxx).send(yyy)でエラーが返されたとき
    if (e.response) {
      return {
        error: {
          status: e.response.status,
          message: e.response.data,
        },
      };
    }

    // throwされたエラーが返されたとき(e.response = undefined)
    return {
      error: {
        status: 500,
        message: 'internal error',
      },
    };
  }
};
